import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { getFlowKey } from '../routing/getFlowKey';
export const useLoadingTitle = ({
  loadingKey
}) => {
  const flowKey = getFlowKey();
  const titleWithFlowKey = `loading.${loadingKey}.${flowKey}.title`;
  const subTitleWithFlowKey = `loading.${loadingKey}.${flowKey}.subtitle`;
  const titleI18n = isValidI18nKey(`${titleWithFlowKey}_1`) ? titleWithFlowKey : `loading.${loadingKey}.title`;
  const subtitleI18n = isValidI18nKey(`${subTitleWithFlowKey}_1`) ? subTitleWithFlowKey : `loading.${loadingKey}.subtitle`;
  return {
    titleI18n,
    subtitleI18n
  };
};